<section class="guest-flow-info-grid" [attr.aria-label]="'events.details' | translate">
  @if (timeClickable) {
    <button type="button" class="guest-flow-info-card" (click)="timeClick.emit()">
      <ng-container *ngTemplateOutlet="timeContent"></ng-container>
    </button>
  } @else {
    <article class="guest-flow-info-card">
      <ng-container *ngTemplateOutlet="timeContent"></ng-container>
    </article>
  }

  @if (locationClickable) {
    <button type="button" class="guest-flow-info-card" (click)="locationClick.emit()">
      <ng-container *ngTemplateOutlet="locationContent"></ng-container>
    </button>
  } @else {
    <article class="guest-flow-info-card">
      <ng-container *ngTemplateOutlet="locationContent"></ng-container>
    </article>
  }
</section>

<ng-template #timeContent>
  <span class="guest-flow-info-label">{{ timeLabel }}</span>
  <strong class="guest-flow-info-value">{{ timeValue }}</strong>
  @if (timeDetail) {
    <small class="guest-flow-info-detail">{{ timeDetail }}</small>
  }
  <ng-content select="[time-extra]"></ng-content>
</ng-template>

<ng-template #locationContent>
  <span class="guest-flow-info-label">{{ locationLabel }}</span>
  <strong class="guest-flow-info-value">{{ locationValue }}</strong>
  @if (locationDetail) {
    <small class="guest-flow-info-detail">{{ locationDetail }}</small>
  }
  <ng-content select="[location-extra]"></ng-content>
</ng-template>
